<template>
  <section>
    <p>
      ADAS MAP utilizes a VIN Decoder service to identify Vehicle ADAS and Safety systems. The results from this decoding process, often times,
      returns items not pertinent for identifying and inspecting ADAS and Safety systems.
    </p>
    <p>
      As such, you can use this facility to exclude categories from being included in the results presented to users using ADAS MAP. These categories
      must match, <b>exactly</b>, with those coming from the VIN Decoder service.
    </p>
    <!-- Listing Actions -->
    <div class="custom-filter">
      <span> Filter (Matrix Category): </span>
      <select v-model="filter" class="form-control" @change="filterChanged">
        <option v-for="(category, idx) of matrixCategories" :key="idx">
          {{ category }}
        </option>
      </select>
    </div>
    <!-- Listing -->
    <div v-show="loading?.exclusions" class="listingWrapper">
      <div class="custom-spinner"><i class="fas fa-spinner fa-spin"></i></div>
    </div>
    <div class="custom-listing-wrapper">
      <div class="custom-add-button">
        <button class="btn btn-primary btn-sm" @click="addExclusion">Add</button>
      </div>
      <div v-show="!loading.exclusions" ref="listingWrapper" class="listingWrapper">
        <z-table
          v-model="filtered"
          class="table table-bordered table-striped"
          :is-single-row-detail="false"
          sort-on="id"
          sort-dir="asc"
          :columns="tableColumnsName"
          :is-header-fixed="true"
        >
          <template #tbody="props">
            <td class="custom-column-60">
              <a href="#" @click="editExclusion(props.row)">edit</a>
            </td>
            <td>{{ props.row.matrixCategory }}</td>
            <td>{{ props.row.item }}</td>
            <td>{{ props.row.value }}</td>
            <td class="custom-column-60">{{ setValueType(props.row) }}</td>
            <td class="custom-column-60">
              <a href="#" @click="confirmDelete(props.row)">delete</a>
            </td>
          </template>
          <template #empty> Nothing found! </template>
        </z-table>
      </div>
    </div>
    <!-- Dialogs -->
    <dialog-exclusion v-model="actionExclusion" @closing="closeModal" @saved="savedExclusion" />
    <confirm-delete
      v-model="actionDelete"
      :confirm-title="confirmTitle"
      :confirm-action="confirmAction"
      :confirm-question="confirmQuestion"
      @closing="closeModal"
      @proceed="performDelete"
    />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZTable from '@/components/utilities/elements/Table.vue'
import DialogExclusion from './dialog-exclusion.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
export default {
  name: 'AdasExclusions',
  components: {
    ZTable,
    DialogExclusion,
    ConfirmDelete
  },
  data() {
    return {
      actionExclusion: null,
      actionDelete: null,
      confirmTitle: 'Delete this Exclusion?',
      confirmAction: 'Delete',
      confirmQuestion: 'Are you sure you wish to Delete this Exclusion?',
      filter: 'all'
    }
  },
  mounted() {
    this.filter = 'all'
    this.getAdasExclusions()
  },
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'exclusions']),
    tableColumnsName() {
      return [
        {
          field: 'adasChecklistExclusion',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'item',
          label: 'Matrix Category',
          sortable: false
        },
        {
          field: 'item',
          label: 'Decode Category Exclusion',
          sortable: false
        },
        {
          field: 'value',
          label: 'Attribute Exclusion',
          sortable: false
        },
        {
          field: 'isValueType',
          label: 'Excluded?',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'adasChecklistExclusion',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        }
      ]
    },
    matrixCategories() {
      let _data = []
      _data.push('all')
      _data.push('')
      if (this.exclusions !== undefined && this.exclusions !== null) {
        this.exclusions.forEach((element) => {
          if (element.matrixCategory !== null) {
            let found = _data.find((x) => x === element.matrixCategory)
            if (!found) {
              _data.push(element.matrixCategory)
            }
          }
        })
      }
      return _data
    },
    filtered() {
      let _data = []
      if (this.exclusions !== undefined && this.exclusions !== null) {
        let clone = JSON.parse(JSON.stringify(this.exclusions))
        if (this.filter !== null) {
          if (this.filter !== 'all') {
            if (this.filter === '') {
              _data = clone.filter((x) => x.matrixCategory === null)
            } else {
              _data = clone.filter((x) => x.matrixCategory === this.filter)
            }
          } else {
            _data = clone
          }
        } else {
          _data = clone
        }
      }
      return _data
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['getAdasExclusions', 'deleteAdasExclusion']),
    closeModal() {
      this.actionExclusion = null
      this.actionDelete = null
    },
    addExclusion() {
      this.actionExclusion = {
        adasChecklistExclusion: null,
        item: '',
        value: '',
        isValueType: false,
        type: 'ADD'
      }
    },
    editExclusion(row) {
      this.actionExclusion = {
        adasChecklistExclusion: row.adasChecklistExclusion,
        item: row.item,
        value: row.value,
        isValueType: row.isValueType,
        type: 'EDIT'
      }
    },
    async savedExclusion() {
      this.actionExclusion = null
      await this.getAdasExclusions()
    },
    confirmDelete(row) {
      this.actionDelete = row
    },
    async performDelete(row) {
      this.actionDelete = null
      console.log('Deleting Exclusion', row.adasChecklistExclusion)
      await this.deleteAdasExclusion(row.adasChecklistExclusion)
      await this.getAdasExclusions()
    },
    setValueType(row) {
      let is = ''
      if (row.isValueType) {
        is = 'Y'
      }
      return is
    },
    filterChanged(e) {
      console.log('Filter Changed', {
        event: e,
        value: this.filter
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-host {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}
.custom-listing-wrapper {
  position: relative;
}
.listingWrapper {
  position: relative;
  overflow-y: auto;
  max-height: 550px;
  width: 100%;
}
.custom-wrapper {
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
}
.custom-spinner {
  width: 100%;
  text-align: center;
  font-size: 1.1em;
}
.custom-add-button {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 15;
}
.custom-filter {
  width: 100%;
  display: inline-flex;
  margin-bottom: 10px;
  span {
    width: 240px;
    text-align: right;
    margin-right: 5px;
  }
  select {
    width: 350px;
  }
}
</style>
